import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ReviewApplyOption } from '@common/reviews/enums/review-apply-option.enum';
import { DialogBase } from '@portal-core/ui/dialog/util/dialog.base';

export interface ReviewPackageResolveChangesDialogData {
  unresolvedFileNames?: string[];
}

export interface ReviewPackageResolveChangesDialogResult {
  action: ReviewApplyOption;
}

interface ReviewPackageResolveChangesDialogForm {
  action: FormControl<ReviewApplyOption>
}


@Component({
  selector: 'mc-review-package-resolve-changes-dialog',
  templateUrl: './review-package-resolve-changes-dialog.component.html',
  styleUrls: ['./review-package-resolve-changes-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ReviewPackageResolveChangesDialogComponent extends DialogBase<ReviewPackageResolveChangesDialogComponent, ReviewApplyOption> implements OnInit {
  static DialogConfig: MatDialogConfig = {
    width: '60rem'
  };

  ReviewPackageResolveChangesOption = ReviewApplyOption;
  unresolvedFileNames?: string[];
  action?: ReviewApplyOption;
  reviewPackageResolveChangesDialogForm: FormGroup<ReviewPackageResolveChangesDialogForm>;

  constructor(@Inject(MAT_DIALOG_DATA) private data: ReviewPackageResolveChangesDialogData,
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<ReviewPackageResolveChangesDialogComponent, ReviewApplyOption>,
    private fb: FormBuilder
  ) {
    super(dialog, dialogRef);
  }

  ngOnInit() {
    super.ngOnInit();
    this.unresolvedFileNames = this.data.unresolvedFileNames;
    this.buildForm();
  }

  private buildForm() {
    this.reviewPackageResolveChangesDialogForm = this.fb.group({
      action: new FormControl<ReviewApplyOption>(null, Validators.required),
    });
  }

  onSubmit() {
    this.closeDialog(this.reviewPackageResolveChangesDialogForm.controls.action.value, true);
  }
}
